export enum ArticleSearchCategory {
	alerts = 'alerts',
	shoutouts = 'shoutouts',
	drops = 'drops',
	market = 'market',
	museum = 'museum',
	legal = 'legal',
	shows = 'shows',
	nft = 'NFT',
	exclusives = 'exclusives',
	people = 'people',
}

export enum ArticleSearchField {
	artists = 'artists',
	categories = 'categories',
	geotag = 'geotag',
	tags = 'tags',
}

export const BASE_SEARCH_CATEGORIES_MAP = Object.freeze({
	[ArticleSearchCategory.shoutouts]: 'ShoutOuts',
	[ArticleSearchCategory.exclusives]: 'Exclusives',
	[ArticleSearchCategory.drops]: 'Drops',
	[ArticleSearchCategory.market]: 'Market',
	[ArticleSearchCategory.museum]: 'Museum',
	[ArticleSearchCategory.legal]: 'Legal',
	[ArticleSearchCategory.people]: 'People',
	[ArticleSearchCategory.shows]: 'Shows',
});

export const BASE_SEARCH_CATEGORIES_MAP_WITHOUT_SHOUTOUT = Object.freeze({
	[ArticleSearchCategory.alerts]: 'Alerts',
	[ArticleSearchCategory.exclusives]: 'Exclusives',
	[ArticleSearchCategory.people]: 'People',
	[ArticleSearchCategory.shows]: 'Shows',
	[ArticleSearchCategory.market]: 'Market',
	[ArticleSearchCategory.museum]: 'Museum',
	[ArticleSearchCategory.legal]: 'Legal',
});

// Shows / Profiles / Market / Museum / Legal / All;
export const SEARCH_CATEGORIES = [
	'top',
	ArticleSearchCategory.exclusives,
	ArticleSearchCategory.alerts,
	ArticleSearchCategory.people,
	ArticleSearchCategory.shows,
	ArticleSearchCategory.market,
	ArticleSearchCategory.museum,
	ArticleSearchCategory.legal,
];
